<div class="modal-header">
  <h4 class="modal-title float-left">Verstuurde emails naar @if (signatory) {
    <span>{{ signatory.name }}</span>
  }</h4>
</div>

@if (signatory) {
  <div class="modal-body">
    <div class="emails">
      <table class="table table-sm">
        <thead>
          <tr>
            <th scope="col">Datum</th>
            <th scope="col">Onderwerp</th>
            <th scope="col">Ontvanger</th>
            <th scope="col">Status</th>
          </tr>
        </thead>
        <tbody>
          @for (emailStateReport of signatory.emailStateReports; track emailStateReport) {
            <tr>
              <td>{{ emailStateReport.added | amFromUtc | amLocale:'nl' | amLocal | amDateFormat: 'LLL' }} </td>
              <td>{{ emailStateReport.subject }}</td>
              <td>{{ emailStateReport.toAddress }}</td>
              <td [class]="stateClass(emailStateReport.state)"><strong>{{ 'emailstate.' + emailStateReport.state | translate }}</strong></td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="">
      <button class="btn btn-outline-danger" (click)="bsModalRef.hide()">Sluiten</button>
    </div>
  </div>
}
